module.exports = __webpack_public_path__ + "assets/img/txt-message.c2b40eba.png";